import a from "react";
import { getIconColor as d } from "./iconfont.es5470.js";
import x from "./iconfont.es5471.js";
const i = {
  display: "block"
}, f = ({ size: e = 16, useVw: l, useRem: n, color: c, withColor: o, removeClassName: t, disableSSR: m, style: r, ...p }) => {
  const E = r ? { ...i, ...r } : i;
  return /* @__PURE__ */ a.createElement(x, { disableSSR: m }, /* @__PURE__ */ a.createElement("svg", { "data-icon-id": "32px-ETHwakuang", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 32 32", width: l ? ((e || 0) / 375 * 100).toFixed(5) + "vw" : e + (n ? "rem" : "px"), height: l ? ((e || 0) / 375 * 100).toFixed(5) + "vw" : e + (n ? "rem" : "px"), className: t ? "" : "iconpark-icon", style: E, fill: "none", ...p }, /* @__PURE__ */ a.createElement(
    "g",
    {
      className: t ? "" : "32px-ETHæç¿"
    },
    /* @__PURE__ */ a.createElement(
      "g",
      {
        className: t ? "" : "normal",
        fill: o ? d(c, 0, "#262933") : "#262933",
        datafollowfill: o ? d(c, 0, "#262933") : "#262933"
      },
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M4.9 16C4.9 9.87 9.87 4.9 16 4.9S27.1 9.87 27.1 16a.9.9 0 1 0 1.8 0c0-7.124-5.775-12.9-12.9-12.9C8.876 3.1 3.1 8.876 3.1 16c0 7.125 5.776 12.9 12.9 12.9a.9.9 0 1 0 0-1.8C9.87 27.1 4.9 22.13 4.9 16Z"
        }
      ),
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M14.035 12.504a4.623 4.623 0 0 1 4.502 1.068 4.623 4.623 0 0 1 1.326 4.433 1 1 0 0 0 1.946.46 6.623 6.623 0 0 0-1.9-6.348 6.623 6.623 0 0 0-6.446-1.53 1 1 0 0 0 .572 1.917Z"
        }
      ),
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M17.488 14.513a1 1 0 0 1 .062 1.413l-4.813 5.25a1 1 0 0 1-1.474-1.352l4.812-5.25a1 1 0 0 1 1.413-.061Z"
        }
      ),
      /* @__PURE__ */ a.createElement(
        "path",
        {
          clipRule: "evenodd",
          d: "M28.355 20.222a.884.884 0 0 0-1.262-.86l-5.277 2.517a.884.884 0 0 0-.504.801l.02 5.315a.884.884 0 0 0 1.22.815l4.848-1.99a.884.884 0 0 0 .546-.755l.41-5.843Zm-5.26 6.453-.012-3.441 3.402-1.623-.265 3.782-3.124 1.282Z",
          fillRule: "evenodd"
        }
      )
    )
  )));
}, s = f;
export {
  s as default
};
